import cn from 'classnames';

export type DrawerHeaderProps = {
  title: string;
  description?: React.ReactNode;
  hasDarkBackground?: boolean;
};

export const DrawerHeader = ({ title, description, hasDarkBackground }: DrawerHeaderProps) => (
  <div className="flex flex-col items-center justify-center gap-2 md:gap-4 text-center md:text-left px-[16px] md:px-0">
    <h2
      className={cn('text-h2 md:text-56/65 font-500 tracking-tight', {
        'text-white pt-[48px] md:pt-[120px]': hasDarkBackground,
        'text-black': !hasDarkBackground,
      })}
    >
      {title}
    </h2>
    <div className="md:text-21/28 text-gray-700">{description}</div>
  </div>
);
